<div class="input-group stc-input-group" *ngIf="control">
  <label>
    {{ inputName }}
    <mat-error *ngIf="control.hasError('required')">* </mat-error>
  </label>

  <mat-form-field>
    <input
      matInput
      [matDatepicker]="picker"
      [id]="inputId"
      [name]="inputName"
      [formControl]="control"
      [min]="minDate"
      [max]="maxDate"
      [placeholder]="inputPlaceholder"
      [readonly]="disabledInput"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker
      #picker
      [startView]="'multi-year'"
      (monthSelected)="setMonthAndYear($event, picker)"
      panelClass="month-year-picker"
    ></mat-datepicker>

    <mat-error *ngIf="control.hasError('required')">
      {{ 'field_required' | translate }}
    </mat-error>
  </mat-form-field>
</div>